import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

// Actions
import * as DisputeUciActions from '../../modules/DisputeUciActions'
import { doHidePopup } from 'Store/actions/popup'

// Component
import DisputeDownloadModal from './DisputeDownloadModal'

// Utilities
import { nullSafe } from 'Utility/globalMethods'

const mapDispatchToProps = (dispatch) => ({
  doHidePopup: () => dispatch(doHidePopup()),
  ...bindActionCreators(DisputeUciActions, dispatch)
})

const mapStateToProps = (state) => ({
  dossierStatus: nullSafe(() => state.popup.popupInfo.dossierStatus, ''),
  dossierSubStatus: nullSafe(() => state.popup.popupInfo.dossierSubStatus, ''),
  totalRecords: nullSafe(() => state.popup.popupInfo.totalRecords, 0),
  filterParams: nullSafe(() => state.popup.popupInfo.filterParams, {}),
  downloadLoading: nullSafe(() => state.DisputeUci.downloadLoading, false)
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(DisputeDownloadModal)
